module.exports = __webpack_public_path__ + "static/media/icon-live-casino.95b330c6.svg";